import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { IN_REACT_NATIVE } from 'sh-www/constants/environment';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class SignupRoute extends Route {
  @service router;
  @service session;

  redirect() {
    const { currentUser } = this.session;

    const requiresFunnel =
      !currentUser ||
      (currentUser.isSeller && currentUser.signupStep !== 'done');

    if (!requiresFunnel) {
      this.router.replaceWith('start');
    }
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.onAuthSuccess.cancelAll({ resetState: true });
      controller.onGoogleSSO.cancelAll({ resetState: true });
      controller.onSignupForm.cancelAll({ resetState: true });
    }
  }

  activate(transition) {
    super.activate(...arguments);

    if (IN_REACT_NATIVE) {
      this.controllerFor('application').setProperties({
        simpleHeaderRightText: 'Cancel',
        simpleHeaderRightAction: () => this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNIN),
      });
    }

    trackPageViewFromTransition(this, transition, '/signup/');
  }

  deactivate() {
    super.deactivate();

    this.controllerFor('application').setProperties({
      simpleHeaderRightText: '',
      simpleHeaderRightAction: null,
    });
  }
}

export default SignupRoute;
